<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-9 col-12">
                    <h6 class="h2 text-white d-inline-block mb-0">Dashboard</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                    <div class="form-group row mt-3">
                        <div class="col-md-3 col-sm-12">
                            <base-input>
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="{ allowInput: true }"
                                    class="form-control datepicker"
                                    v-model="startDate"
                                >
                                </flat-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <base-input>
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    :config="{ allowInput: true }"
                                    class="form-control datepicker"
                                    v-model="endDate"
                                >
                                </flat-picker>
                            </base-input>
                        </div>
                        <div class="col-md-2 col-sm-12">
                            <base-input>
                                <el-select v-model="dateType" :placeholder="$t('date_type')" @change="handleSearch()">
                                    <el-option :label="$t('created_date')"  value="createddate"></el-option>
                                    <el-option :label="$t('packing_date')"  value="packingdate"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <base-input>
                                <el-select v-model="platformId" :placeholder="$t('platform')" filterable>
                                    <el-option
                                        v-for="option in platformOptions"
                                        :key="option.id"
                                        :label="option.name"
                                        :value="option.id"
                                    >
                                    </el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-1 col-sm-12">
                            <base-button size="md" type="primary" @click="handleSearch()">
                                {{ $t('search') }}
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Total summary cards -->
            <div class="row">
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_unpaid')" type="gradient-red" :sub-title="Unpaid" icon="ni ni-active-40"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_awaiting_shipment')" type="gradient-orange" :sub-title="AwaitingShipment" icon="ni ni-chart-pie-35"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_awaitingcollection')" type="gradient-info" :sub-title="AwaitingCollection" icon="ni ni-money-coins"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_awaiting_transit')" type="gradient-info" :sub-title="AwaitingTransit" icon="fa fa-box"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_intransit')" type="gradient-green" :sub-title="InTransit" icon="fa fa-truck"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_delivered')" type="gradient-green" :sub-title="Delivered" icon="ni ni-chart-bar-32"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_completed')" type="gradient-green" :sub-title="Completed" icon="fa fa-check"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_cancelled')" type="gradient-red" :sub-title="Cancel" icon="fa fa-trash"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_returned')" type="gradient-red" :sub-title="Returned" icon="fa fa-window-close"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_returning')" type="gradient-warning" :sub-title="Returning" icon="fa fa-undo"></stats-card>
                </div>
                <div class="col-xl-3 col-md-6">
                    <stats-card :title="$t('order_status_claimed')" type="gradient-orange" :sub-title="Claim" icon="fa fa-exclamation-triangle"></stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="card">
                <div class="card-header">
                    <h3 class="mb-0">{{ $t('platform') }}</h3>
                </div>
                <div class="card-body p-0">
                    <el-table :data="byPlatform" stripe style="width: 100%" :row-class-name="rowClassPlatform">
                        <el-table-column :label="$t('platform')" min-width="140">
                            <template slot-scope="{ row }">
                                <strong v-if="row.platform_id === 0">{{ $t('all') }}</strong>
                                <span v-else>{{ row.platform_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_unpaid')" min-width="80">
                            <template slot-scope="{ row }">{{ (row.status || {}).Unpaid || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_awaiting_shipment')" min-width="100">
                            <template slot-scope="{ row }">{{ (row.status || {}).AwaitingShipment || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_awaitingcollection')" min-width="100">
                            <template slot-scope="{ row }">{{ (row.status || {}).AwaitingCollection || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_awaiting_transit')" min-width="100">
                            <template slot-scope="{ row }">{{ (row.status || {}).AwaitingTransit || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_intransit')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).InTransit || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_delivered')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Delivered || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_completed')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Completed || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_cancelled')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Cancel || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_returned')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Returned || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_returning')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Returning || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_claimed')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Claim || 0 }}</template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <h3 class="mb-0">{{ $t('sale_channel') }}</h3>
                </div>
                <div class="card-body p-0">
                    <el-table :data="bySaleChannel" stripe style="width: 100%" :row-class-name="rowClassChannel">
                        <el-table-column :label="$t('sale_channel')" min-width="160">
                            <template slot-scope="{ row }">
                                <strong v-if="row.sale_channel_id === 0">{{ $t('all') }}</strong>
                                <span v-else>{{ row.sale_channel_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_unpaid')" min-width="80">
                            <template slot-scope="{ row }">{{ (row.status || {}).Unpaid || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_awaiting_shipment')" min-width="100">
                            <template slot-scope="{ row }">{{ (row.status || {}).AwaitingShipment || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_awaitingcollection')" min-width="100">
                            <template slot-scope="{ row }">{{ (row.status || {}).AwaitingCollection || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_awaiting_transit')" min-width="100">
                            <template slot-scope="{ row }">{{ (row.status || {}).AwaitingTransit || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_intransit')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).InTransit || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_delivered')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Delivered || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_completed')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Completed || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_cancelled')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Cancel || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_returned')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Returned || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_returning')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Returning || 0 }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('order_status_claimed')" min-width="90">
                            <template slot-scope="{ row }">{{ (row.status || {}).Claim || 0 }}</template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import StatsCard from "@/components/Cards/StatsCard";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { Select, Option, Table, TableColumn } from "element-ui";
import { mapActions } from "vuex";
import moment from "moment";
import swal from "sweetalert2";

export default {
    components: {
        StatsCard,
        flatPicker,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            startDate: "",
            endDate: "",
            platformId: 0,
            dateType: "createddate",

            AwaitingCollection: "0",
            AwaitingShipment: "0",
            AwaitingTransit: "0",
            Cancel: "0",
            Claim: "0",
            Completed: "0",
            Delivered: "0",
            InTransit: "0",
            PartiallyShipping: "0",
            Returned: "0",
            Returning: "0",
            Unpaid: "0",

            byPlatform: [],
            bySaleChannel: []
        };
    },
    computed: {
        platformOptions() {
            return [
                { id: 0, name: this.$t('all') },
                { id: 1, name: "MadameFin" },
                { id: 2, name: "Tiktok" },
                { id: 3, name: "Shopee" },
                { id: 4, name: "Lazada" }
            ];
        }
    },
    methods: {
        ...mapActions({
            listData: "Report/listReportDashboard"
        }),
        rowClassPlatform({ row }) {
            return row.platform_id === 0 ? 'dashboard-all-row' : '';
        },
        rowClassChannel({ row }) {
            return row.sale_channel_id === 0 ? 'dashboard-all-row' : '';
        },
        enforceMaxRange() {
            const from = moment(this.startDate);
            const to = moment(this.endDate);
            if (!from.isValid() || !to.isValid()) return true;
            if (to.isBefore(from)) {
                swal.fire({ text: this.$t('date') + ' invalid', icon: 'warning' });
                return false;
            }
            if (to.diff(from, 'days') > 6) {
                swal.fire({ text: 'Maximum date range is 7 days', icon: 'warning' });
                return false;
            }
            return true;
        },
        async handleSearch() {
            if (!this.enforceMaxRange()) return;

            let params = {
                time_from: this.startDate,
                time_to: this.endDate,
                platform_id: this.platformId,
                date_type: this.dateType,
            };

            try {
                let response = await this.listData(params);
                let datum = response.data.Datum;
                let status = datum.Status || {};
                this.AwaitingCollection = (status.AwaitingCollection || 0).toString();
                this.AwaitingShipment = (status.AwaitingShipment || 0).toString();
                this.AwaitingTransit = (status.AwaitingTransit || 0).toString();
                this.Cancel = (status.Cancel || 0).toString();
                this.Claim = (status.Claim || 0).toString();
                this.Completed = (status.Completed || 0).toString();
                this.Delivered = (status.Delivered || 0).toString();
                this.InTransit = (status.InTransit || 0).toString();
                this.Returned = (status.Returned || 0).toString();
                this.Returning = (status.Returning || 0).toString();
                this.Unpaid = (status.Unpaid || 0).toString();
                this.byPlatform = datum.ByPlatform || [];
                this.bySaleChannel = datum.BySaleChannel || [];
            } catch (err) {
                swal.fire({
                    text: (err.response && err.response.data && err.response.data.Msg) || "error",
                    title: "err.",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            }
        }
    },
    mounted() {
        this.startDate = moment().add(-6, "days").format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
        this.handleSearch();
    }
};
</script>
<style>
.dashboard-all-row {
    background-color: #f1f5fb !important;
    font-weight: 600;
}
</style>
